// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-ayRjx";
var _4 = "ticket-1u17n";
var _5 = "request-kwmhl";
var _6 = "receipt-2UKYU";
var _7 = "notifications-3a8Jj";
var _8 = "notification-DR3_V";
var _9 = "ticket__flights-34GR1";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "ticket", _5 as "request", _6 as "receipt", _7 as "notifications", _8 as "notification", _9 as "ticket__flights" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "ticket": _4, "request": _5, "receipt": _6, "notifications": _7, "notification": _8, "ticket__flights": _9 }
